export enum BookingStatus {
  PAYMENT_MISSING = "payment-missing",
  OTHER_PAYMENTS_MISSING = "other-payments-missing",
  RECEPTION_VALIDATION_MISSING = "reception-validation-missing",
  MATCH_READY_TO_PLAY = "match-ready-to-play",
}
